<template>
  <div>
    <div v-if="show">
      <formulas-by-resource-dialog
        v-model="formulas"
        :resourceName="value?.name ?? 'N/A'"
        :subTitle="$t('formula.byResource.includedTag')"
        @cancel="cancel"
        @forceRemove="forceRemove"
      />
      <delete-dialog
        :dialog="deleteConfirmDialog"
        v-on:confirm-delete="remove"
        v-on:cancel-dialog="cancel"
      />
    </div>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import DeleteDialog from "@/components/common/DeleteDialog";
import FormulasByResourceDialog from "@/components/formula/FormulasByResourceDialog";

export default {
  name: "DeleteConstantDialog",

  components: {
    DeleteDialog,
    FormulasByResourceDialog,
  },

  props: {
    show: {
      type: Boolean,
      default: false,
    },

    value: {
      type: Object,
      default: () => ({}),
    },
  },

  model: {
    prop: "value",
  },

  data() {
    return {
      deleteConfirmDialog: false,
      formulas: [],
    };
  },

  methods: {
    ...mapActions("formulas", [
      "deleteConstant",
      "deleteConstantForce",
      "getFormulasByConstant",
    ]),
    ...mapActions("alert", ["success", "error"]),

    async remove() {
      if (
        this.value?.constantId == null ||
        this.value?.constantId == undefined
      ) {
        this.error(this.$t("formula.errors.noId"));
        return;
      }

      (await this.deleteConstant(this.value.constantId))
        ? this.success(this.$t("common.deleted"))
        : this.error(this.$t("formula.errors.delete"));

      this.$emit("update");
    },

    async forceRemove() {
      if (
        this.value?.constantId == null ||
        this.value?.constantId == undefined
      ) {
        this.error(this.$t("formula.errors.noId"));
        return;
      }

      (await this.deleteConstantForce(this.value.constantId))
        ? this.success(this.$t("common.deleted"))
        : this.error(this.$t("formula.errors.delete"));

      this.$emit("update");
    },

    cancel() {
      this.$emit("cancel");
    },
  },

  async created() {
    if (this.value?.constantId) {
      this.formulas = await this.getFormulasByConstant(this.value.constantId);
      if (this.formulas == undefined)
        this.error(this.$t("formula.errors.gettingData"));
    }
  },

  watch: {
    show: {
      //Determines if the constant is a formula resource to show the relevant delete dialog
      async handler(val) {
        if (val) {
          this.formulas = await this.getFormulasByConstant(
            this.value?.constantId
          );
          if (this.formulas == undefined)
            this.error(this.$t("formula.errors.gettingData"));

          this.deleteConfirmDialog =
            this.formulas != undefined && this.formulas.length == 0;
        }
      },
    },
  },
};
</script>
